import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';

import { getInputField, getFormatNumber } from '../subscriptor/forms/fields';
import { maintainerForm as styles } from '../maintainer/styles';
import {
  HEALTH_PLAN_MAX_LENGTH_RANGE,
  HEALTH_PLAN_LENGTH_COVERAGE
} from '../../libraries/constants';
import { maximumSubString } from '../../libraries/utils';

const form = props => {
  const { values, classes, handleBlur, errors, touched, setFieldValue, title } = props;

  const fieldProps = {
    handleBlur,
    classes,
    touched,
    errors,
    values,
    setFieldValue
  };

  return (
    <Card className={classes.card}>
      <CardHeader title={title} className={classes.cardTitle} />
      <CardContent className={classes.cardContent}>
        {values ? (
          <React.Fragment>
            {getInputField({
              ...fieldProps,
              name: `range`,
              label: `Tramo`,
              required: true,
              changeHandler: maximumSubString(HEALTH_PLAN_MAX_LENGTH_RANGE),
              formControlClass: classes.fullWidth
            })}
            {getFormatNumber({
              ...fieldProps,
              name: `coverage`,
              thousandSeparator: '',
              allowEmptyFormatting: true,
              label: 'Porcentaje',
              required: true,
              maxDigitLimit: HEALTH_PLAN_LENGTH_COVERAGE,
              formControlClass: classes.fullWidth
            })}
          </React.Fragment>
        ) : (
          ''
        )}
      </CardContent>
    </Card>
  );
};

form.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(form);
